export enum RateType {
  NHG = 'NHG',
  LTV = 'LTV',
  PAYOUT = 'PAYOUT'
}
